export const roleCodes = {
  admin: 'admin',
  guest: 'guest',
  user: 'user',
}

export const roleIds = {
  1: 'owner',
  2: 'admin',
  3: 'member',
}

// Nguồn duy nhất cho permission key phía client - PHẢI khớp 1-1 với key trong
// config/permissions.php (BE, schema entity_role). Thêm key mới ở đây trước,
// không hard-code string 'organization_manage_xxx' rải rác nơi khác.
// (organization_view_member: chưa có nhu cầu tách riêng khỏi manage_member ở client, bỏ qua.)
export const organizationPermissionCodes = {
  organizationManageEdit: 'edit',
  organizationManageEvent: 'organization_manage_event',
  organizationManageChannel: 'organization_manage_channel',
  organizationManagePost: 'organization_manage_post',
  organizationManageAnnouncement: 'organization_manage_announcement',
  organizationManageMember: 'organization_manage_member',
  organizationViewMember: 'organization_view_member',
  organizationManageGroup: 'organization_manage_group',
  organizationManageInfo: 'organization_manage_settings',
  organizationManageRole: 'organization_manage_role',
  organizationManageFeatures: 'organization_manage_features',
  organizationManageGames: 'organization_manage_games',
  organizationManageCourse: 'organization_manage_course',
  organizationManageExamination: 'organization_manage_examination',
  organizationManageSacrament: 'organization_manage_sacrament',
  organizationManageProduct: 'organization_manage_product',
  organizationViewFinance: 'organization_view_finance',
  organizationManageFinance: 'organization_manage_finance',
}

export const permissionCodes = {
  canPost: 'can_post',
  canInvite: 'canInvite',
  canJoin: 'canJoin',
  canSubscribe: 'canSubscribe',
  canBookmark: 'canBookmark',
  canPostArticle: 'canPostArticle',
  canCopy_link: 'canCopy_link',
  canDelete: 'canDelete',
  canEdit: 'canEdit',
  canMessage: 'canMessage',
  canRemove: 'canRemove',
  canShare: 'canShare',
  canTo: 'canTo',
  canView: 'canView',
  canVote: 'canVote',
}
